/** Navigateurs intégrés (Snapchat, Instagram…) : Google OAuth iframe est bloqué. */

const IN_APP_UA = [
  { pattern: /Snapchat/i, label: 'Snapchat' },
  { pattern: /Instagram/i, label: 'Instagram' },
  { pattern: /FBAN|FBAV|Facebook/i, label: 'Facebook' },
  { pattern: /Twitter|X\.com/i, label: 'X' },
  { pattern: /TikTok/i, label: 'TikTok' },
  { pattern: /LinkedIn/i, label: 'LinkedIn' },
  { pattern: /Line\//i, label: 'Line' },
  { pattern: /MicroMessenger/i, label: 'WeChat' },
] as const;

export function detectInAppBrowserFromUserAgent(ua: string): string | null {
  for (const { pattern, label } of IN_APP_UA) {
    if (pattern.test(ua)) return label;
  }
  return null;
}

export function getInAppBrowserName(): string | null {
  if (typeof navigator === 'undefined') return null;
  return detectInAppBrowserFromUserAgent(navigator.userAgent || '');
}

export function isInAppBrowser(): boolean {
  return getInAppBrowserName() !== null;
}

export function getExternalBrowserHint(appName: string | null): string {
  if (appName === 'Snapchat') {
    return 'Appuyez sur ⋮ en haut à droite, puis « Ouvrir dans le navigateur » (Safari ou Chrome).';
  }
  if (appName === 'Instagram') {
    return 'Appuyez sur ⋯ en bas, puis « Ouvrir dans le navigateur externe ».';
  }
  return 'Ouvrez ce lien dans Safari ou Chrome pour vous connecter avec Google.';
}

export async function copyPageUrl(url?: string): Promise<boolean> {
  const target = url ?? window.location.href;
  try {
    await navigator.clipboard.writeText(target);
    return true;
  } catch {
    try {
      const input = document.createElement('textarea');
      input.value = target;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(input);
      return ok;
    } catch {
      return false;
    }
  }
}

/** Tente d’ouvrir l’URL dans le navigateur système (best-effort). */
export function tryOpenExternalBrowser(url?: string): void {
  const target = url ?? window.location.href;
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isIOS) {
    const path = target.replace(/^https:\/\//i, '');
    window.location.assign(`x-safari-https://${path}`);
    return;
  }

  const anchor = document.createElement('a');
  anchor.href = target;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
